import { FC } from "react";
import HighlightPlayer from "../../../Components/VideoPlayer";

import React, { ChangeEvent, useCallback, useState } from "react";
import { useEffect, useRef } from "react";

//@ts-ignore

import { PlayerEvent, Player } from "bitmovin-player";

import "bitmovin-player/bitmovinplayer-ui.css";

//@ts-ignore

import { Box } from "@mui/material";
import { useParams, useSearchParams } from "react-router-dom";
import HttpService from "../../../Hooks/Https-services";
import { APIRoutes } from "../../../Utils/constant";
import useConfig from "../../../Hooks/useConfig";

declare global {
  interface Window {
    bitmovin: any;
  }
}
// v1/condensed-game-search
const GameView: React.FC = () => {
  // Event handler for seek end
  const playerRef: any = useRef();
  const [videoUrl, setVideoUrl] = useState("");
  const [games, setGames] = useState([]);
  const { id } = useParams();
  const [searchParams, setSearchParams] = useSearchParams();
  const [isCondensed, setIsCondensed] = useState(false);
  const [formData, setFormData] = useState({ game_id: id, event: "GOAL" });
  const { api } = useConfig();
  const url = `${api}/v1/${
    isCondensed ? "condensed-game" : "assembly"
  }?game_ids=${formData.game_id}${
    formData.event && `event_types=${formData.event}`
  }`;
  const handleCopy = () => {
    navigator.clipboard
      .writeText(url)
      .then(() => {})
      .catch((err) => {
        console.error("Failed to copy text:", err);
      });
  };
  return (
    <Box sx={{ position: "relative", p: 2 }}>
      <select
        disabled={isCondensed}
        value={formData.event}
        onChange={(e) => setFormData({ ...formData, event: e.target.value })}
      >
        <option value={"GOAL"}>GOALS</option>
        <option value={"HIT"}>HITS</option>
        <option value={"SAVE"}>SAVES</option>
        <option value={"SHIFT"}>SHIFTS</option>
      </select>
      <button
        onClick={() => {
          if (isCondensed) {
            setFormData({ ...formData, game_id: id, event: "GOAL" });
            setIsCondensed(false);
          } else {
            setFormData({ ...formData, game_id: id, event: "" });
            setIsCondensed(true);
          }
        }}
      >
        Condensed game
      </button>
      {searchParams.get("show-url") == "true" && (
        <div style={{ margin: "20px 0px" }}>
          {url}
          <button onClick={handleCopy}>Copy</button>
        </div>
      )}

      <HighlightPlayer
        url={`${api}/v1/${
          isCondensed ? "condensed-game" : "assembly"
        }?game_ids=${id}&event_types=${formData.event}&bypass=true`}
      />
    </Box>
  );
};

export default GameView;
